import React from 'react'
import {Button, Grid} from '@material-ui/core/'
import emailSentImg from '../../assets/images/email-sent-icon.svg'
import MarkdownRender from '../MarkdownRender/MarkdownRender'

const ForgotPasswordEmailSend = props => {
    return (
        <Grid item className="login__contanier email-sent__contanier">
            <Grid item className="login__signin">
                <Grid item className="login__head">
                    <img
                        src={emailSentImg}
                        alt="Email sent"
                        className="email-sent__img"
                    />
                </Grid>
                <Grid container className="login__form">
                    <MarkdownRender
                        value={
                            props.appConfig.supportedLabels.forgotPasswordEmailSend
                                .forgotPasswordInfo
                        }
                    />
                </Grid>
                <Grid item xs className="login__form-action">
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={props.onClickResend}
                    >
                        {
                            props.appConfig.supportedLabels.forgotPasswordEmailSend
                                .resendBtnTxt
                        }
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ForgotPasswordEmailSend
